import { useCurrencyContext } from '../context/CurrencyContext';

export const useSelectedCurrency = () => {
  return useCurrencyContext();
};
